import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/main';
import 'store/customTracking';
import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	checkIfLoaded() {
		const client = this.state?.appState?.client;
		if (client.device === 'desktop' || client.isDesktopSize) {
			const splashReady = this.state?.appState?.main?.splashReady;
			return super.checkIfLoaded() && splashReady;
		}
		const loadingCloudsReady = this.state?.appState?.main?.loadingCloudsReady;
		return super.checkIfLoaded() && loadingCloudsReady;
	}

}
